// Central dictionary for all static UI chrome strings (not service/blog content).
// Usage: t("nav.home") -> "Anasayfa" | "Home" depending on active language.
export const UI_TEXT = {
  // Header / nav
  "nav.home": { tr: "Anasayfa", en: "Home" },
  "nav.about": { tr: "Hakkımızda", en: "About" },
  "nav.services": { tr: "Hizmetler", en: "Services" },
  "nav.blog": { tr: "Blog", en: "Blog" },
  "nav.contact": { tr: "İletişim", en: "Contact" },
  "header.cta": { tr: "Teklif Alın", en: "Get a Quote" },
  "header.menuToggle": { tr: "Menüyü aç/kapat", en: "Toggle menu" },
  "header.langSwitchTo": { tr: "EN", en: "TR" },
  "header.langSwitchLabel": { tr: "İngilizceye geç", en: "Switch to Turkish" },

  // Logo
  "logo.tagline": { tr: "KKDİK Danışmanlık", en: "KKDİK Consultancy" },

  // Footer
  "footer.blurb": {
    tr: "KKDİK madde kayıt süreçleri ve kimyasal mevzuat uyumluluğunda butik, teknik odaklı danışmanlık.",
    en: "Boutique, technically-focused consultancy for KKDİK substance registration and chemicals-regulation compliance.",
  },
  "footer.services": { tr: "Hizmetler", en: "Services" },
  "footer.corporate": { tr: "Kurumsal", en: "Company" },
  "footer.contact": { tr: "İletişim", en: "Contact" },
  "footer.location": { tr: "İstanbul, Türkiye", en: "Istanbul, Türkiye" },
  "footer.rights": { tr: "Tüm hakları saklıdır.", en: "All rights reserved." },
  "footer.strapline": {
    tr: "Teknik doğruluk · Güvenilirlik · Şeffaf iletişim",
    en: "Technical accuracy · Reliability · Transparent communication",
  },

  // Home
  "home.badge": { tr: "Kimyasal Değerlendirme Uzmanı Danışmanlık", en: "Chemical Assessment Expert Consultancy" },
  "home.heroTitleLine1": { tr: "KKDİK Madde Kayıt", en: "KKDİK Substance Registration" },
  "home.heroTitlePrefix": { tr: "Süreçlerinde", en: "Processes with" },
  "home.heroTitleEm": { tr: "güvenilir", en: "reliable" },
  "home.heroTitleSuffix": { tr: "teknik destek", en: "technical support" },
  "home.heroLead": {
    tr: "Kimyasal madde kayıt süreçleri ve kimyasal mevzuat uyumluluğu alanında teknik danışmanlık sunuyoruz. İthalatçı ve üreticilere uzaktan, Türkçe ve İngilizce destek sağlıyoruz.",
    en: "We provide technical consultancy on chemical substance registration and chemicals-regulation compliance. We support importers and manufacturers remotely, in Turkish and English.",
  },
  "home.ctaServices": { tr: "Hizmetlerimizi İnceleyin", en: "Explore Our Services" },
  "home.ctaQuote": { tr: "Teklif Alın", en: "Get a Quote" },
  "home.heroImageAlt": { tr: "Laboratuvar bilimsel görsel", en: "Scientific laboratory imagery" },
  "home.heroCardKicker": { tr: "Mevzuat", en: "Regulation" },
  "home.heroCardTitle": { tr: "KKDİK & SEA Uyumluluk", en: "KKDİK & SEA Compliance" },

  "home.servicesKicker": { tr: "Hizmetlerimiz", en: "Our Services" },
  "home.servicesTitlePrefix": { tr: "Kayıttan etiketlemeye, uçtan uca", en: "From registration to labelling, end-to-end" },
  "home.servicesTitleEm": { tr: "teknik destek", en: "technical support" },
  "home.servicesLead": {
    tr: "KKDİK, SEA, UFI/PCN ve teknik dosya hazırlığı dahil tüm kritik süreçlerde işletmenizin yanındayız.",
    en: "We stand by your business across every critical process — including KKDİK, SEA, UFI/PCN, and technical dossier preparation.",
  },
  "home.serviceDetailLink": { tr: "Detay", en: "Details" },

  "home.whyKicker": { tr: "Neden Biz?", en: "Why Us?" },
  "home.whyTitlePrefix": { tr: "Butik bir yaklaşım,", en: "A boutique approach," },
  "home.whyTitleEm": { tr: "teknik", en: "technical" },
  "home.whyTitleSuffix": { tr: "derinlik.", en: "depth." },
  "home.whyLead": {
    tr: "Her projeye birebir ilgi gösterir, hızlı iletişim ve çözüm odaklı bir çalışma anlayışıyla ilerleriz.",
    en: "We give every project one-on-one attention, moving forward with fast communication and a solution-focused approach.",
  },
  "home.whyPoint1": { tr: "Aynı iş gününde ilk dönüş", en: "First response on the same business day" },
  "home.whyPoint2": { tr: "Uzaktan, lokasyon bağımsız hizmet", en: "Remote, location-independent service" },
  "home.whyPoint3": { tr: "Mevzuat uyumlu çıktı garantisi", en: "Regulation-compliant output guarantee" },

  "home.valuesTitle": {
    tr: "Değerlerimiz — her ilişkide aynı disiplinle uyguladığımız ilkeler.",
    en: "Our values — the principles we apply with the same discipline in every relationship.",
  },

  "home.blogKicker": { tr: "Blog", en: "Blog" },
  "home.blogTitlePrefix": { tr: "KKDİK ve mevzuat üzerine", en: "Technical notes on KKDİK" },
  "home.blogTitleEm": { tr: "teknik notlar", en: "and regulations" },
  "home.blogAll": { tr: "Tüm yazılar", en: "All articles" },
  "home.blogRead": { tr: "Yazıyı oku", en: "Read article" },
  "home.blogMinutes": { tr: "dk", en: "min" },

  "home.ctaKicker": { tr: "İlk Görüşme Ücretsiz", en: "Free Initial Consultation" },
  "home.ctaTitle": {
    tr: "İhtiyaçlarınızı birlikte değerlendirelim, yol haritanızı çıkaralım.",
    en: "Let's assess your needs together and map out your roadmap.",
  },
  "home.ctaLead": {
    tr: "KKDİK, SEA, SDS veya UFI/PCN süreçleri için projenize özel bir teklif ve zaman planı sunuyoruz.",
    en: "We provide a proposal and timeline tailored to your project for KKDİK, SEA, SDS, or UFI/PCN processes.",
  },
  "home.ctaWhatsapp": { tr: "WhatsApp ile yazın", en: "Message us on WhatsApp" },

  // About
  "about.kicker": { tr: "Hakkımızda", en: "About Us" },
  "about.titlePrefix": { tr: "Karmaşık kimyasal mevzuatı,", en: "We make complex chemicals legislation" },
  "about.titleEm": { tr: "anlaşılır", en: "understandable" },
  "about.titleSuffix": { tr: "ve yönetilebilir kılıyoruz.", en: "and manageable." },
  "about.lead": {
    tr: "Kimyasal Değerlendirme Uzmanı olarak edindiğimiz sektör deneyimi ve teknik bilgi birikimi ile işletmelerin KKDİK ve ilgili kimyasal mevzuat kapsamındaki yükümlülüklerini doğru ve etkin şekilde yerine getirmelerine destek oluyoruz.",
    en: "With the industry experience and technical know-how we have built as Chemical Assessment Experts, we help businesses meet their obligations under KKDİK and related chemicals legislation accurately and effectively.",
  },
  "about.imageAlt": { tr: "Profesyonel ofis görseli", en: "Professional office imagery" },
  "about.storyTitle": { tr: "Butik bir teknik danışmanlık girişimi", en: "A boutique technical consultancy" },
  "about.storyP1": {
    tr: "Kimyasal mevzuat süreçlerinin karmaşık yapısını daha anlaşılır ve yönetilebilir hale getirmek amacıyla kurulduk. Her projeye birebir ilgi gösteriyor, hızlı iletişim ve çözüm odaklı çalışma anlayışını benimsiyoruz.",
    en: "We were founded to make the complex structure of chemicals-regulation processes more understandable and manageable. We give every project one-on-one attention and embrace a fast, solution-focused way of working.",
  },
  "about.storyP2": {
    tr: "Hizmetlerimizi uzaktan (remote) model ile Türkçe ve İngilizce olarak sunuyor; teknik doğruluk, güvenilirlik ve şeffaf iletişim ilkeleri üzerine kurulu uzun vadeli iş ilişkileri inşa ediyoruz.",
    en: "We deliver our services remotely, in both Turkish and English, and build long-term business relationships founded on technical accuracy, reliability, and transparent communication.",
  },
  "about.missionTitle": { tr: "Misyon", en: "Mission" },
  "about.missionText": {
    tr: "Kimyasal madde kayıt süreçlerini işletmeler için erişilebilir, anlaşılır ve yönetilebilir hale getirerek teknik bilgiye dayalı güvenilir danışmanlık sunmak.",
    en: "To make chemical substance registration processes accessible, understandable, and manageable for businesses by providing reliable, knowledge-based technical consultancy.",
  },
  "about.visionTitle": { tr: "Vizyon", en: "Vision" },
  "about.visionText": {
    tr: "KKDİK ve kimyasal mevzuat alanında güvenilirliği ve teknik yaklaşımıyla tercih edilen butik danışmanlık markalarından biri olmak.",
    en: "To be one of the preferred boutique consultancy brands in the field of KKDİK and chemicals legislation, known for reliability and a technical approach.",
  },
  "about.valuesKicker": { tr: "Değerlerimiz", en: "Our Values" },
  "about.valuesTitle": {
    tr: "Her ilişkide aynı disiplinle uyguladığımız ilkeler.",
    en: "The principles we apply with the same discipline in every relationship.",
  },
  "about.valuesLead": {
    tr: "Müşterilerimiz için sürdürülebilir, uzun vadeli iş ilişkileri kurarken sürekli gelişim ve müşteri odaklı yaklaşımı temel alıyoruz.",
    en: "As we build sustainable, long-term business relationships with our clients, we base our work on continuous improvement and a customer-focused approach.",
  },
  "about.ctaTitle": {
    tr: "Projeniz için doğru yol haritasını birlikte oluşturalım.",
    en: "Let's build the right roadmap for your project together.",
  },
  "about.ctaButton": { tr: "İletişime Geçin", en: "Get in Touch" },

  // Services listing page
  "services.kicker": { tr: "Hizmetlerimiz", en: "Our Services" },
  "services.titlePrefix": { tr: "KKDİK kayıt sürecinin her aşamasında", en: "Technical support at every stage" },
  "services.titleEm": { tr: "teknik destek", en: "of the KKDİK registration process" },
  "services.lead": {
    tr: "Madde kayıt sürecini sadeleştiriyor, mevzuat yükümlülüklerinizi eksiksiz ve doğru biçimde yerine getirmenize destek oluyoruz. Her hizmet için detaylı bilgilere göz atabilirsiniz.",
    en: "We simplify the substance-registration process and help you meet your regulatory obligations completely and accurately. You can review detailed information for each service.",
  },
  "services.detailLink": { tr: "Detaylı bilgi", en: "Learn more" },
  "services.processKicker": { tr: "Sürecimiz", en: "Our Process" },
  "services.processTitle": { tr: "Net bir yol haritası, şeffaf bir süreç.", en: "A clear roadmap, a transparent process." },
  "services.process.step1.title": { tr: "Keşif Görüşmesi", en: "Discovery Call" },
  "services.process.step1.desc": { tr: "İhtiyaç analizi ve mevzuat kapsamının netleştirilmesi.", en: "Needs analysis and clarification of the regulatory scope." },
  "services.process.step2.title": { tr: "Teklif & Plan", en: "Proposal & Plan" },
  "services.process.step2.desc": { tr: "Süre, kapsam ve maliyet için yazılı teklif sunumu.", en: "A written proposal covering timeline, scope, and cost." },
  "services.process.step3.title": { tr: "Uygulama", en: "Implementation" },
  "services.process.step3.desc": { tr: "Dosya hazırlığı, koordinasyon ve teknik raporlama.", en: "Dossier preparation, coordination, and technical reporting." },
  "services.process.step4.title": { tr: "Teslim & Takip", en: "Delivery & Follow-up" },
  "services.process.step4.desc": { tr: "Bildirim sonrası izleme ve revizyon desteği.", en: "Post-submission monitoring and revision support." },

  // Service detail page
  "serviceDetail.badgeFallback": { tr: "Hizmet", en: "Service" },
  "serviceDetail.faqTitle": { tr: "Sık Sorulan Sorular", en: "Frequently Asked Questions" },
  "serviceDetail.sidebarKicker": { tr: "Hızlı Aksiyon", en: "Quick Action" },
  "serviceDetail.sidebarTitle": { tr: "Bilgi almak ister misiniz?", en: "Would you like more information?" },
  "serviceDetail.sidebarLead": {
    tr: "Projeniz için ücretsiz ön değerlendirme ve teklif sunuyoruz.",
    en: "We offer a free preliminary assessment and proposal for your project.",
  },
  "serviceDetail.quoteForm": { tr: "Teklif Formu", en: "Quote Form" },
  "serviceDetail.whatsapp": { tr: "WhatsApp ile Bilgi Al", en: "Ask on WhatsApp" },
  "serviceDetail.scopeKicker": { tr: "Bu hizmet kapsamında", en: "Included in this service" },
  "serviceDetail.relatedKicker": { tr: "Diğer Hizmetler", en: "Other Services" },
  "serviceDetail.relatedTitle": {
    tr: "İlgilendiğiniz başka bir alan var mı?",
    en: "Interested in another area?",
  },
  "serviceDetail.allServices": { tr: "Tüm hizmetler", en: "All services" },
  "serviceDetail.backToServices": { tr: "Hizmetlere dön", en: "Back to services" },

  // Breadcrumbs
  "breadcrumb.home": { tr: "Anasayfa", en: "Home" },
  "breadcrumb.services": { tr: "Hizmetler", en: "Services" },

  // Contact
  "contact.kicker": { tr: "İletişim", en: "Contact" },
  "contact.titlePrefix": { tr: "İhtiyaçlarınızı dinleyelim,", en: "Let's hear your needs and" },
  "contact.titleEm": { tr: "yol haritanızı", en: "build your roadmap" },
  "contact.titleSuffix": { tr: "birlikte oluşturalım.", en: "together." },
  "contact.lead": {
    tr: "KKDİK kayıt süreçleri ve kimyasal mevzuat konularında teknik destek almak için bizimle iletişime geçin. İlk görüşme ücretsizdir.",
    en: "Get in touch for technical support on KKDİK registration processes and chemicals-regulation matters. The first consultation is free.",
  },
  "contact.directTitle": { tr: "Doğrudan İletişim", en: "Direct Contact" },
  "contact.directLead": {
    tr: "Aynı iş günü içinde size geri dönüyoruz. Acil talepleriniz için WhatsApp üzerinden yazabilirsiniz.",
    en: "We get back to you within the same business day. For urgent requests, you can message us on WhatsApp.",
  },
  "contact.email": { tr: "E-posta", en: "Email" },
  "contact.phone": { tr: "Telefon", en: "Phone" },
  "contact.whatsapp": { tr: "WhatsApp", en: "WhatsApp" },
  "contact.whatsappCta": { tr: "Hızlı mesaj gönderin", en: "Send a quick message" },
  "contact.location": { tr: "Konum", en: "Location" },
  "contact.locationValue": { tr: "İstanbul, Türkiye", en: "Istanbul, Türkiye" },
  "contact.remoteNote": { tr: "Uzaktan çalışma modeli", en: "Remote-working model" },
  "contact.hoursTitle": { tr: "Çalışma Saatleri", en: "Working Hours" },
  "contact.monFri": { tr: "Pazartesi – Cuma", en: "Monday – Friday" },
  "contact.sat": { tr: "Cumartesi", en: "Saturday" },
  "contact.sun": { tr: "Pazar", en: "Sunday" },
  "contact.formTitle": { tr: "Bize yazın", en: "Write to us" },
  "contact.formLead": {
    tr: "Talebinizi kısaca anlatın, en kısa sürede yanıtlayalım.",
    en: "Briefly describe your request and we'll respond as soon as possible.",
  },
  "contact.fieldName": { tr: "Ad Soyad *", en: "Full Name *" },
  "contact.fieldNamePlaceholder": { tr: "Adınız Soyadınız", en: "Your full name" },
  "contact.fieldCompany": { tr: "Firma", en: "Company" },
  "contact.fieldCompanyPlaceholder": { tr: "Firma adı (opsiyonel)", en: "Company name (optional)" },
  "contact.fieldEmail": { tr: "E-posta *", en: "Email *" },
  "contact.fieldEmailPlaceholder": { tr: "ornek@firma.com", en: "you@company.com" },
  "contact.fieldPhone": { tr: "Telefon", en: "Phone" },
  "contact.fieldPhonePlaceholder": { tr: "+90 5xx xxx xx xx", en: "+90 5xx xxx xx xx" },
  "contact.fieldSubject": { tr: "Konu", en: "Subject" },
  "contact.fieldSubjectPlaceholder": { tr: "Bir konu seçin (opsiyonel)", en: "Select a subject (optional)" },
  "contact.fieldMessage": { tr: "Mesajınız *", en: "Your Message *" },
  "contact.fieldMessagePlaceholder": { tr: "Talebinizi kısaca anlatın...", en: "Briefly describe your request..." },
  "contact.consentNote": {
    tr: "Formu göndererek bizimle iletişime geçmek istediğinizi onaylarsınız.",
    en: "By submitting this form, you confirm that you wish to contact us.",
  },
  "contact.submit": { tr: "Mesajı Gönder", en: "Send Message" },
  "contact.sending": { tr: "Gönderiliyor...", en: "Sending..." },
  "contact.errorRequired": {
    tr: "Lütfen ad soyad, e-posta ve mesaj alanlarını doldurun.",
    en: "Please fill in your name, email, and message fields.",
  },
  "contact.errorGeneric": { tr: "Bir hata oluştu. Lütfen tekrar deneyin.", en: "Something went wrong. Please try again." },
  "contact.errorSend": { tr: "Mesaj gönderilemedi. Lütfen tekrar deneyin.", en: "The message could not be sent. Please try again." },
  "contact.success": {
    tr: "Mesajınız başarıyla alındı. En kısa sürede dönüş yapacağız.",
    en: "Your message has been received. We'll get back to you shortly.",
  },
  "contact.subjectOther": { tr: "Diğer", en: "Other" },
  "contact.emailSubjectPrefix": { tr: "Yeni İletişim Formu Mesajı", en: "New Contact Form Message" },
  "contact.emailSubjectGeneral": { tr: "Genel", en: "General" },

  // Blog
  "blog.kicker": { tr: "Blog", en: "Blog" },
  "blog.titlePrefix": { tr: "KKDİK ve kimyasal mevzuat üzerine", en: "Technical notes on KKDİK and" },
  "blog.titleEm": { tr: "notlar", en: "chemicals regulation" },
  "blog.lead": {
    tr: "Süreçleri sadeleştiren rehberler, sıkça yapılan hatalar ve mevzuat güncellemeleri üzerine kısa teknik içerikler.",
    en: "Short technical articles with process guides, common mistakes, and regulatory updates.",
  },
  "blog.empty": { tr: "Henüz yazı yok.", en: "No articles yet." },
  "blog.readArticle": { tr: "Yazıyı oku", en: "Read article" },
  "blog.minutes": { tr: "dk", en: "min" },
  "blog.contentNotice": {
    tr: "",
    en: "Article content is currently published in Turkish only.",
  },
  "blogPost.backToBlog": { tr: "Bloga dön", en: "Back to blog" },
  "blogPost.notFound": { tr: "Yazı bulunamadı.", en: "Article not found." },
  "blogPost.allArticles": { tr: "Tüm yazılar", en: "All articles" },
  "blogPost.minutes": { tr: "dakika", en: "min read" },
  "blogPost.otherArticles": { tr: "Diğer yazılar", en: "Other articles" },
  "blogPost.ctaConsult": { tr: "Danışmanlık talep edin", en: "Request a consultation" },

  // Floating buttons
  "floating.whatsappMsg": {
    tr: "Merhaba, KKDİK madde kayıt süreçleri hakkında bilgi almak istiyorum.",
    en: "Hello, I'd like information about KKDİK substance registration processes.",
  },
  "floating.whatsappAria": { tr: "WhatsApp ile iletişime geç", en: "Contact us on WhatsApp" },
  "floating.phoneAria": { tr: "Telefon ile ara", en: "Call us" },

  // 404
  "notFound.title": { tr: "Aradığınız sayfa bulunamadı.", en: "The page you're looking for wasn't found." },
  "notFound.lead": { tr: "Sayfa taşınmış veya kaldırılmış olabilir.", en: "The page may have been moved or removed." },
  "notFound.backHome": { tr: "Anasayfaya dön", en: "Back to homepage" },
};

export default UI_TEXT;
